// extracted by mini-css-extract-plugin
module.exports = {"imgprovider":"imageAuthor-module--imgprovider--AMMQS"};